import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

import { FORMATO_COPA, esPorJornadas } from "@/Constant/FormatoTorneo";
import { etiquetaPartidaCopa } from "@/utils/cuadroCopa";
import { computed, ref } from "vue";
import { ViewPartidaTorneoDTO } from "@/interfaces/Partidas";
import { formatFechaSpaWhitoutAsync } from "@/utils/Fecha";
import { motivoSinLista, SIN_LISTA } from "@/utils/avisoLista";
import { getlistaTorneo } from "@/services/ListasService";
import CardPartidaLectura, {
  JugadorPartidaLectura,
} from "@/components/Commons/CardPartidaLectura.vue";
import ModalListaResultadoTorneo from "@/components/ResultadosTorneos/ModalListaResultadoTorneo.vue";
import ModalError from "@/components/Commons/ModalError.vue";

//eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'CardPartidaTorneo',
  props: {
    match: {},
    idUsuario: {},
    mostrarTorneo: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props;

const isLoadingLista = ref<boolean>(false);
const isModalListaVisible = ref<boolean>(false);
const showErrorLista = ref<boolean>(false);
const mensajeErrorLista = ref<string>("");
const listaData = ref<string>("");
const nickJugador = ref<string>("");
const ejercitoLista = ref<string>();

const contexto = computed(() =>
  [
    props.mostrarTorneo ? props.match.nombreTorneo : "",
    props.match.formatoTorneo === FORMATO_COPA && props.match.fase && props.match.numeroRonda
      ? etiquetaPartidaCopa(
          {
            fase: props.match.fase,
            grupo: props.match.grupo,
            numeroRonda: props.match.numeroRonda,
          },
          null,
          props.match.rondasEliminatoria
        )
      : props.match.numeroRonda
        ? `${esPorJornadas(props.match.formatoTorneo) ? "Jornada" : "Ronda"} ${props.match.numeroRonda}`
        : "",
  ]
    .filter(Boolean)
    .join(" · ")
);

// Solo en Parejas: compañeros de los capitanes
const companero1 = computed<JugadorPartidaLectura | null>(() =>
  props.match.idCompanero1
    ? {
        idUsuario: props.match.idCompanero1,
        nick: props.match.nickCompanero1 ?? undefined,
        ejercito: props.match.ejercitoCompanero1,
      }
    : null
);
const companero2 = computed<JugadorPartidaLectura | null>(() =>
  props.match.idCompanero2
    ? {
        idUsuario: props.match.idCompanero2,
        nick: props.match.nickCompanero2 ?? undefined,
        ejercito: props.match.ejercitoCompanero2,
      }
    : null
);

// ELO del jugador del perfil en esta partida; en Parejas los dos de un lado ganan o pierden lo mismo
const eloVariacion = computed(() => {
  if (
    props.idUsuario === props.match.idUsuario1 ||
    props.idUsuario === props.match.idCompanero1
  )
    return props.match.eloVariacionUsuario1 ?? null;
  if (
    props.idUsuario === props.match.idUsuario2 ||
    props.idUsuario === props.match.idCompanero2
  )
    return props.match.eloVariacionUsuario2 ?? null;
  return null;
});

const verLista = async (jugador: JugadorPartidaLectura) => {
  if (!props.match.idTorneo) return;
  isLoadingLista.value = true;
  try {
    const response = await getlistaTorneo({
      idTorneo: props.match.idTorneo,
      idUsuario: jugador.idUsuario,
    });
    // Sin lista el modal se quedaría cargando para siempre: mejor avisar
    if (!response.data?.listaData) {
      mensajeErrorLista.value = SIN_LISTA;
      showErrorLista.value = true;
      return;
    }
    listaData.value = response.data.listaData;
    nickJugador.value = jugador.nick ?? "";
    ejercitoLista.value = response.data.ejercito ?? jugador.ejercito ?? "";
    isModalListaVisible.value = true;
  } catch (error) {
    console.error("Error al cargar la lista:", error);
    mensajeErrorLista.value = motivoSinLista(error);
    showErrorLista.value = true;
  } finally {
    isLoadingLista.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CardPartidaLectura, {
      contexto: contexto.value,
      fecha: _unref(formatFechaSpaWhitoutAsync)(_ctx.match.fechaPartida),
      jugador1: {
        idUsuario: _ctx.match.idUsuario1,
        nick: _ctx.match.nickUsuario1,
        ejercito: _ctx.match.ejercitoUsuario1,
        puntos: _ctx.match.resultadoUsuario1,
        companero: companero1.value,
      },
      jugador2: {
        idUsuario: _ctx.match.idUsuario2,
        nick: _ctx.match.nickUsuario2,
        ejercito: _ctx.match.ejercitoUsuario2,
        puntos: _ctx.match.resultadoUsuario2,
        companero: companero2.value,
      },
      escenario: _ctx.match.escenarioPartida,
      puntosPartida: _ctx.match.puntosPartida || _ctx.match.puntosTorneo,
      idGanador: _ctx.match.ganadorPartidaTorneo,
      idUsuarioDestacado: _ctx.idUsuario,
      listasVisibles: !!_ctx.match.idTorneo && _ctx.match.mostrarListas === true,
      eloVariacion: eloVariacion.value,
      onVerLista: verLista
    }, null, 8, ["contexto", "fecha", "jugador1", "jugador2", "escenario", "puntosPartida", "idGanador", "idUsuarioDestacado", "listasVisibles", "eloVariacion"]),
    (isModalListaVisible.value)
      ? (_openBlock(), _createBlock(ModalListaResultadoTorneo, {
          key: 0,
          listaData: listaData.value,
          nickJugador: nickJugador.value,
          ejercito: ejercitoLista.value,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (isModalListaVisible.value = false))
        }, null, 8, ["listaData", "nickJugador", "ejercito"]))
      : _createCommentVNode("", true),
    _createVNode(ModalError, {
      isVisible: showErrorLista.value,
      titulo: "Aviso",
      message: mensajeErrorLista.value,
      "onUpdate:isVisible": _cache[1] || (_cache[1] = ($event: any) => (showErrorLista.value = $event))
    }, null, 8, ["isVisible", "message"]),
    _createVNode(_component_v_dialog, {
      modelValue: isLoadingLista.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isLoadingLista).value = $event)),
      persistent: "",
      width: "300"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, {
              class: "d-flex justify-center align-center",
              style: {"height":"150px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_progress_circular, {
                  indeterminate: "",
                  color: "blue-lighten-3",
                  size: 57
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})